module.exports = __webpack_public_path__ + "img/message_remove.ecd0cce2.svg";